'use strict';

var defImplDataHandler = {};
//===================================================================================================

defImplDataHandler.getPatientID = function (row, i, GUID) {

  if (!GUID) {
    if (!row['patientID']) {
      return i;
    } else {
      return row['patientID'];
    }
  }

  return row[GUID];
};
//===================================================================================================

defImplDataHandler.getPatientName = function (row, i) {
  return 'mr. F. Lastname';
};
//===================================================================================================

module.exports = defImplDataHandler;